export interface BillingSolutionRangeInterface {
  id?: number;
  min: number;
  max: number;
  units: number;
  createdAt?: string;
  updatedAt?: string;
  billingSolutionId?: number;
  _destroy?: boolean;
}

export class BillingSolutionRange implements BillingSolutionRangeInterface {
  id?: number;
  min: number;
  max: number;
  units: number;
  createdAt?: string;
  updatedAt?: string;
  billingSolutionId?: number;
  _destroy?: boolean;

  constructor(data: Partial<BillingSolutionRangeInterface>) {
    this.id = data.id;
    this.min = data.min || 0;
    this.max = data.max || 0;
    this.units = data.units || 0;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.billingSolutionId = data.billingSolutionId;
    this._destroy = data._destroy || false;
  }

  toJson(): BillingSolutionRangeInterface {
    const json: BillingSolutionRangeInterface = {
      min: this.min,
      max: this.max,
      units: this.units,
      _destroy: this._destroy,
    };

    if (this.id) {
      json.id = this.id;
    }

    if (this.billingSolutionId) {
      json.billingSolutionId = this.billingSolutionId;
    }

    return json;
  }
}
